module.exports = __webpack_public_path__ + "img/files.03f9a078.svg";